module.exports = __webpack_public_path__ + "img/party-popper_image.baf74e30.svg";